import React, { Component } from 'react';
import axios from 'axios';
import Print from 'rc-print';

class FullDirectory extends Component {
  state = {
    directors: []
  };
  componentDidMount() {
    this.getDirector();
  }

  getDirector() {
    const department = this.props.department;
    axios.get(`/api/get-director/${department}`).then(res => {
      this.setState({ directors: res.data });
    });
  }
  render() {
    const { directors } = this.state;
    const map = directors.map(e => {
      let num = e.work_phone && e.work_phone.split('');
    num = e.work_phone && ['( ',
      num.slice(0, 3),
      ' )',
      ' - ',
      num.slice(3, 6),
      ' - ',
      num.slice(6)
    ];
      return (
        <div className="directors_map" key={e.id}>
          <p>
            {e.first_name} {e.last_name}
          </p>
          <p>{e.position}</p>
          <p>{e.school}</p>
          <p>{e.isd}</p>
          <p>{num}</p>
          <p>{e.email}</p>
        </div>
      );
    });
    return (
      <div>
        <Print ref="test">
          <div>
            <div className="fd_top">
              <p>Name</p>
              <p>Position</p>
              <p>School</p>
              <p>ISD</p>
              <p>Phone</p>
              <h2>Email</h2>
            </div>
            <div className="directors_big_map">{map}</div>
          </div>
        </Print>
        <div className="print_holder">
          <h3
            className="print_btn"
            onClick={() => {
              this.refs.test.onPrint();
            }}
          >
            Print
          </h3>
        </div>
      </div>
    );
  }
}

export default FullDirectory;



// WEBPACK FOOTER //
// ./src/Components/Directory/FullDirectory/FullDirectory.js